// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OcRrG","content":"styles_content__PAnZ2"};